/** Walk every cell list in a table. Identity-preserving when `mapList` is. */
export const mapTableCellLists = (block, mapList) => {
  const td = block.props?.tableData;
  if (block.type !== 'table' || !td) return block;
  let changed = false;
  const headers = (td.headers || []).map((cell) => {
    if (!Array.isArray(cell)) return cell;
    const next = mapList(cell);
    if (next !== cell) changed = true;
    return next;
  });
  const rows = (td.rows || []).map((row) =>
    (row || []).map((cell) => {
      if (!Array.isArray(cell)) return cell;
      const next = mapList(cell);
      if (next !== cell) changed = true;
      return next;
    })
  );
  return changed
    ? { ...block, props: { ...block.props, tableData: { ...td, headers, rows } } }
    : block;
};

export const tableCellLists = (block) => {
  const td = block?.type === 'table' ? block.props?.tableData : null;
  if (!td) return [];
  return [...(td.headers || []), ...(td.rows || []).flat()];
};
